export class Modal {
  constructor() {
    this.modal = document.getElementById('modal');
    this.svgPreview = document.getElementById('svgPreview');
    this.svgText = document.getElementById('svgText');
    this.copyBtn = document.getElementById('copyBtn');
    this.closeBtn = document.getElementById('closeBtn');
    
    this.setupEventListeners();
  }

  setupEventListeners() {
    this.copyBtn.addEventListener('click', () => {
      const text = this.svgText.value;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(text);
      } else {
        alert('Clipboard API not supported. Please copy manually.');
      }
    });

    this.closeBtn.addEventListener('click', () => {
      this.hide();
    });

    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') this.hide();
    });
  }

  show(svgContent) {
    this.svgPreview.innerHTML = '';
    for (let i = 0; i < 9; i++) {
      this.svgPreview.innerHTML += svgContent;
    }
    this.svgText.value = svgContent;
    this.modal.style.display = 'flex';
  }

  hide() {
    this.modal.style.display = 'none';
  }
} 